import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { SaleDocumentsService } from '../../sale-documents/sale-documents/sale-documents.service';
import { SaleOrder } from './sale-order.model';
import { SaleOrderHeaderStatus } from '../sale-order-header-statuses/sale-order-header-status.model';

@Injectable({
  providedIn: 'root'
})
export class SaleOrdersService extends SaleDocumentsService<SaleOrder, SaleOrderHeaderStatus> {
  public override url: string = 'SaleOrderHeader';
  
  public override defaultOptions: LoadOptions = {
    expand: [
      'CurrentStatusLink.StatusId',
      'ResponsibleUserId',
      'Lines($orderby=LineNo;$expand=TaxRateId($expand=NameTranslationId),UnitId,Margin,Discount,Children,SaleDocumentLineDiscountOperations,ParentId,TaxId,AccountId, ProductId)',
      'Statuses.StatusId',
      'DocumentDataCollection.ThirdId.ThirdContacts',
      'DocumentDataCollection.ThirdId.Addresses',
      'DocumentDataCollection.ContactId',
      'DocumentDataCollection.AddressId',
      'DocumentDataCollection.DeliveryAddressId',
      'Payments.PaymentMethodPrimary',
      'Payments.ParentId',
      'Payments.PaymentStateId',          
      'Payments.PaymentTypeId',   
      'ThirdId.ContactInformations.ThirdId',
      'ThirdId.ContactInformations.ContactTypeId',
      'DocumentRelations'
    ]
  };

  public override async getInstance(order?: Partial<SaleOrder>): Promise<any> {

    let element = {
      Date: new Date(),
      ...order,
    };

    element = await this.refreshResponsibleUser(element);
    element = await this.refreshThirdDocumentDelayFromCustomer(element);

    return element;
  }
}
